export default {
  pid: 'Id de publicación',
  pids: 'Ids de publicaciones',
  operator: 'Operador',
  user: 'Usuario',
  sacCallId: 'Id de Conversación',
  channel: 'Canal',
  field: 'Campo',
  operation: 'Operación',
  value: 'Valor',
  date: 'Fecha',
  operators: 'Operadores',
  users: 'Usuarios',
  sacCallIds: 'Ids de Conversaciones',
  export: 'Exportar como XLSX',
  theme: 'Tema',
  polarity: 'Sentimiento',
  tag: 'Etiqueta',
  checked: 'Marcado',
  status: 'Estado',
  replier: 'Operador',
  answered_by: 'Respondido por',
  spam: 'Eliminado',
  oldValue: 'Valor anterior',
  newValue: 'Valor nuevo',
  infoLabel: 'Información del Componente',
  filterLabel: 'Aplicar filtro',
  trashLabel: 'Limpiar filtro',
  closeLabel: 'Cerrar información',
  statusLabel: 'Estado',
  viewPost: 'Ver publicación',
  openChatLabel: 'Abrir conversación',
  interactionType: 'Tipo de interacción',
  pageName: 'Página',
  pagesName: 'Páginas',
  seeConversation: 'Ver conversación',
  set: 'Definir',
  add: 'Agregar',
  remove: 'Eliminar',
  gender: 'Género',
  importeddata: 'Datos importados',
  polarityTypes: {
    '3': 'Neutro',
    '2': 'Negativo',
    '1': 'Positivo',
    '0': 'Sin Sentimiento',
    '-2': 'No Clasificado',
    '-1': 'Negativo',
    '': 'Desconocido',
  },
  genderTypes: {
    '1': 'Hombre',
    '2': 'Mujer',
    '3': 'Organización',
    '0': 'No Clasificado',
    '7': 'Organización',
    '': 'Desconocido',
  },
  faq: {
    title: '¿Cómo cambiar el Operador?',
    description: 'Para cambiar el filtro, haga clic en el campo "Operadores", seleccione los Operadores deseados y haga clic en el ícono de "filtro" en la parte superior derecha de la tabla. Solo se mostrarán las anotaciones de los operadores seleccionados.',
  },
  faq2: {
    title: '¿Cómo filtrar por Operador e Id de Conversación?',
    description: 'Para filtrar por operador y conversación, primero seleccione los Operadores como en el ejemplo anterior. Luego en el campo "Ids de Conversaciones" ingrese el Id deseado (para seleccionar más de uno, sepárelos con coma). Solo se mostrarán las anotaciones de los operadores seleccionados en la conversación requerida.',
  },
  faq3: {
    title: '¿Cómo restablecer el filtro?',
    description: 'Para restablecer el filtro, haga clic en el ícono de "papelera" debajo del ícono de "filtro". Esto restablecerá todos los filtros de la tabla al estado predeterminado.',
  },
  faq4: {
    title: '¿Qué sucede si se elimina una publicación?',
    description: 'Si se elimina una publicación, sus anotaciones no aparecerán en la tabla cuando se use el filtro por id de conversación.',
  },
  faq5: {
    title: '¿Cuánto tiempo tarda en cargarse los datos?',
    description: 'Existe un retraso de 300000 milisegundos (5 minutos) para la inserción de datos en la tabla.',
  },
  faq6: {
    title: '¿Cómo cambiar el usuario?',
    description: 'Para cambiar el filtro, haga clic en el campo "Usuarios", seleccione los Usuarios deseados y haga clic en el ícono de "filtro" en la parte superior derecha de la tabla. Solo se mostrarán las anotaciones de los operadores seleccionados.',
  },
  faq7: {
    title: '¿Cómo filtrar por usuario e Id de publicación?',
    description: 'Para filtrar por usuario y publicación, primero seleccione los usuarios como en el ejemplo anterior. Luego en el campo "Ids de Conversaciones" ingrese el Id deseado (para seleccionar más de uno, sepárelos con coma). Solo se mostrarán las anotaciones de los operadores seleccionados en la conversación requerida.',
  },
  faq8: {
    title: '¿Cuál es el tamaño máximo de exportación?',
    description: 'El componente permite exportar hasta 90000 filas a la vez.',
  },
  question: {
    title: '¿Qué es?',
    description: 'Porcentaje del nivel de SLA de 12 horas basado en la cantidad de casos respondidos y cerrados en relación al número total de casos.',
  },
  question2: {
    title: '¿Qué es?',
    description: 'Tabla atemporal que contiene las conversaciones pendientes más antiguas.',
  },
  question3: {
    title: '¿Qué es?',
    description: 'Gráfico con los cambios de estado realizados en las conversaciones de Smart Care por operador.',
  },
  question4: {
    title: '¿Qué estados aparecen en el gráfico?',
    description: 'Cerrado, Respondido, Ignorado',
  },
  annotatedField: 'Campo anotado',
  username: 'Nombre de usuario',
  noPostsLabel: 'No se encontró ninguna publicación',
  details: 'Detalles de Interacción/Conversación',
  user: 'Usuario',
  group: 'Grupo',
  interest: 'Interés',
  exportAsPNGLabel: 'Exportar como PNG',
  noSLAScoreLabel: 'No encontramos conversaciones para medir el SLA con el filtro seleccionado',
  sla: 'SLA',
  hour: 'Hora',
  minute: 'Minuto',
  smartcareUpdateDate: 'SLA actualizado',
  smartcareDate: 'Fecha Smart Care',
};
